import { IImageAsset } from '../contentful';
import { getResponsiveContentfulImageUrl, progressiveJpegOptions } from '../ui';

export function getCardImageSource(image?: IImageAsset) {
	if (!image) {
		return undefined;
	}

	const { url } = image.fields.file;

	return getResponsiveContentfulImageUrl(url, {
		fit: 'thumb',
		w: 600,
		...progressiveJpegOptions,
	});
}
